export const DEFAULT_AGENT_DATA = {
  agentName: '',
  agentRole: '',
  reProjectIds: [],
};
